import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Parent Dashboard -> quick-action: request a brand-new lesson booking.
// Extracted from ParentDashboard.js (props-driven, no behavior change).
export const NewLessonRequestDialog = ({ open, onOpenChange, students, form, onFormChange, submitting, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="new-lesson-request-dialog">
      <DialogHeader>
        <DialogTitle>Schedule a Driving Lesson</DialogTitle>
      </DialogHeader>
      <div className="space-y-3">
        <p className="text-sm text-muted-foreground">
          Tell the office when you&apos;d like a lesson — they&apos;ll confirm a time and instructor and notify you.
        </p>
        {(students || []).length > 1 && (
          <div className="space-y-1.5">
            <Label>Student</Label>
            <select
              className="w-full h-11 rounded-[var(--radius)] border bg-background px-3 text-sm"
              value={form.student_id}
              onChange={(e) => onFormChange((f) => ({ ...f, student_id: e.target.value }))}
              data-testid="new-lesson-student-select"
            >
              {students.map((s) => (
                <option key={s.id} value={s.id}>{s.full_name}</option>
              ))}
            </select>
          </div>
        )}
        <div className="space-y-1.5">
          <Label>Preferred time</Label>
          <Input
            value={form.preferred_time}
            onChange={(e) => onFormChange((f) => ({ ...f, preferred_time: e.target.value }))}
            placeholder="e.g. Weekday afternoons, or next Saturday morning"
            data-testid="new-lesson-preferred-time-input"
          />
        </div>
        <div className="space-y-1.5">
          <Label>Notes (optional)</Label>
          <Textarea
            value={form.reason}
            onChange={(e) => onFormChange((f) => ({ ...f, reason: e.target.value }))}
            placeholder="Anything the office should know"
            data-testid="new-lesson-notes-input"
          />
        </div>
      </div>
      <DialogFooter>
        <Button onClick={onSubmit} disabled={submitting} data-testid="new-lesson-request-submit-button">
          {submitting ? "Sending..." : "Send Request"}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
